import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Comodato } from '../page/comodato/comodato';
import { PaginacaoComodato } from '../page/comodato/paginacaoComodato';

@Injectable({
  providedIn: 'root'
})
export class ComodatoService {

  apiURL: string = environment.apiBaseUrl + 'comodato';

  constructor(private http: HttpClient) { }

  save(comodato: Comodato): Observable<Comodato> {
    return this.http.post<Comodato>(this.apiURL, comodato);
  }

  list(page: number, size: number): Observable<PaginacaoComodato> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(comodato: Comodato): Observable<any> {
    return this.http.put<Comodato>(`${this.apiURL}/${comodato.id}`, comodato);
  }
  

  findClientById(id: number): Observable<Comodato> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<Comodato> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findClient(page: number, size: number,parametroConsulta: any): Observable<PaginacaoComodato> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}/client/${parametroConsulta}?${params.toString()}`);
  }
  
}